import { Dialog } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import React, { useMemo } from 'react'

import { pluralize } from '../../../../utils/textTools'
import AutoShipItem from './AutoShipItem'
import {
  ModalButtonBox,
  ModalCloseButton,
  ModalContainer,
  ModalContent,
  ModalExtraItemsText,
  ModalHeader,
  ModalItems,
  ModalNoButton,
  ModalText,
  ModalTitle,
  ModalYesButton,
} from './styled'
import { AutoShipCancelResumeModalProps } from './types'

const AutoShipCancelResumeModal: React.FC<AutoShipCancelResumeModalProps> = ({
  isOpen,
  toggleModal,
  status,
  confirm,
  itemsAndProducts,
  autoShipNumber,
}) => {
  const memoized = useMemo(() => {
    const numberOfItemsToShow = 3
    const totalNumberOfItems = itemsAndProducts.length
    const itemsToShow = itemsAndProducts.slice(0, numberOfItemsToShow)
    const numberOfExtraItems = totalNumberOfItems - numberOfItemsToShow
    return {
      numberOfItemsToShow,
      totalNumberOfItems,
      itemsToShow,
      numberOfExtraItems,
    }
  }, [itemsAndProducts])

  const { numberOfItemsToShow, totalNumberOfItems, itemsToShow, numberOfExtraItems } = memoized

  return (
    <Dialog open={isOpen} onClose={toggleModal}>
      <ModalContainer>
        <ModalHeader>
          <ModalTitle>
            {status === 'SUSPENDED' ? 'Pause' : 'Re-Activate'} Auto-Ship #{autoShipNumber}
          </ModalTitle>
          <ModalCloseButton onClick={toggleModal}>
            <Close />
          </ModalCloseButton>
        </ModalHeader>
        <ModalContent>
          <ModalText>
            Are you sure you want to {status === 'SUSPENDED' ? 'pause' : 're-activate'}{' '}
            auto-shipment of{' '}
            {pluralize({
              count: totalNumberOfItems,
              word: 'this product',
              pluralOverride: 'these products',
            })}
            ?
          </ModalText>
          {status === 'ACTIVE' && (
            <ModalText>
              We will use the card on file for this order. It will be charged on the day of the next
              scheduled shipment.
            </ModalText>
          )}
          <ModalItems>
            {itemsToShow.map(([item, product]) => (
              <AutoShipItem item={item} key={item.sku} product={product} />
            ))}
          </ModalItems>
          {totalNumberOfItems > numberOfItemsToShow && (
            <ModalExtraItemsText>
              ... and {numberOfExtraItems} other{' '}
              {pluralize({
                count: totalNumberOfItems - numberOfItemsToShow,
                word: 'item',
              })}
              .
            </ModalExtraItemsText>
          )}
          <ModalButtonBox>
            <ModalNoButton text="No, go back" onClick={toggleModal} />
            <ModalYesButton
              text={status === 'SUSPENDED' ? 'Yes, pause Auto-Ship' : 'Re-activate Now'}
              onClick={confirm}
            />
          </ModalButtonBox>
        </ModalContent>
      </ModalContainer>
    </Dialog>
  )
}

export default AutoShipCancelResumeModal
